import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { connect } from 'react-redux';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import IframeElementCallback from './IframeElementCallback';
import './IframModal.scss';

class MaxIframeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      url: null,
      className: null,
      height: '800px',
      isHideClose: false,
    };
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.iframeElementCallback);
  }

  showModal = (params) => {
    let { url, className, height, title, isHideClose } = params;
    this.setState({
      visible: true,
      url,
      className,
      height,
      title,
      isHideClose,
    });
    window.addEventListener('message', this.iframeElementCallback);
  };

  hideModal = () => {
    this.setState({
      visible: false,
      url: null,
      className: null,
      height: '800px',
    });
    window.removeEventListener('message', this.iframeElementCallback);
  };

  iframeElementCallback = (msg) => {
    IframeElementCallback(this.props, msg, this.iframeElement, this.hideModal);
  };

  render() {
    const { visible, url, className, height, title, isHideClose } = this.state;
    return (
      <Modal
        open={visible}
        wrapClassName="iframe-body"
        centered={true}
        title={null}
        closable={false}
        footer={null}
        keyboard={false}
        maskClosable={false}
        zIndex="1005"
        width="1400px"
      >
        <div className="dolig-iframe-sc noDrag">
          {url && visible ? (
            <span>
              {!isHideClose && (
                <span className={`close ${className}`}>
                  <CloseOutlined onClick={this.hideModal} />
                </span>
              )}
              <iframe
                ref={(el) => (this.iframeElement = el)}
                src={url}
                title={title}
                scrolling="no"
                width="1400px"
                height={height}
              />
            </span>
          ) : null}
        </div>
      </Modal>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(MaxIframeModal, { withRef: true })
);
